import { API } from 'common/constants/urls';
import { get, post, put, del } from 'common/axiosClient';
import {
  Comp,
  CompDivisionDrawsDTO,
  CompLineItem,
  CreateCompLineItemDTO,
  EditCompLineItemDTO,
  UpdateCompDTO,
  UpdateCompDivisionDrawsDTO,
} from './comp.type';

export const getComp = async (compId: string) => {
  return (await get(`${API.COMP_PROJECT_ANALYSIS}/${compId}`)) as Comp;
};

export const updateComp = async (compId: string, updateDTO: UpdateCompDTO) => {
  return (await put(`${API.COMP_PROJECT_ANALYSIS}/${compId}`, updateDTO)) as Comp;
};

export const createCompLineItem = async (compId: string, createDTO: CreateCompLineItemDTO) => {
  return (await post(`${API.COMP_PROJECT_ANALYSIS}/${compId}/line-items`, createDTO)) as CompLineItem;
};

export const updateCompLineItem = async (compId: string, lineItemId: string, updateDTO: EditCompLineItemDTO) => {
  return (await put(`${API.COMP_PROJECT_ANALYSIS}/${compId}/line-items/${lineItemId}`, updateDTO)) as CompLineItem;
};

export const deleteCompLineItem = async (compId: string, lineItemId: string) => {
  return (await del(`${API.COMP_PROJECT_ANALYSIS}/${compId}/line-items/${lineItemId}`)) as boolean;
};

export const getDivisionDraws = async (compId: string) => {
  return (await get(`${API.COMP_PROJECT_ANALYSIS}/${compId}/division-draws`)) as CompDivisionDrawsDTO;
};

export const updateDivisionDraws = async (compId: string, updateDTO: UpdateCompDivisionDrawsDTO) => {
  return (await put(`${API.COMP_PROJECT_ANALYSIS}/${compId}/update-division-draws`, updateDTO)) as boolean;
};
